module.exports = __webpack_public_path__ + "static/img/album4_202501_04.62e5ead.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202501_04.jpg
// module id = LMk0
// module chunks = 100